import { IMAGES } from "@/site";
import { PageHero, Section, SectionTitle, BulletGrid, CTABand } from "@/components/ui-blocks/Blocks";

const WHO = ["New school bus driver applicants","CDL permit holders","Drivers preparing for school bus responsibilities","Returning drivers","Drivers needing pre-trip help","Drivers needing confidence","Drivers needing refresher training","Drivers needing corrective training"];
const LEARN = ["How to inspect a school bus","Understand school bus safety procedures","Use mirrors properly","Understand danger zones","Load and unload students safely","Handle railroad crossings","Control the bus during turns","Avoid preventable accidents","Communicate professionally","Think like a safe driver"];
const GOOD = ["Patient","Alert","Responsible","Professional","Calm under pressure","Safety-focused","Prepared","Dependable","Strong communicator","Willing to learn","Accountable for decisions"];

export default function ForTrainees() {
  return (
    <>
      <PageHero
        testid="trainees-hero"
        eyebrow="For Trainees"
        title="Start your journey."
        description="Becoming a school bus driver is serious work. You are responsible for student safety, safe operation, daily inspections, safe loading and unloading, and emergency preparedness. CLB Solution is being built to help prepare future drivers."
        image={IMAGES.services}
      />

      <Section testid="trainees-who">
        <SectionTitle eyebrow="Who This Is For" title="CLB Solution may support drivers at every stage." />
        <BulletGrid items={WHO} testid="trainees-who-grid" />
      </Section>

      <Section className="bg-[#0c0c0e] border-y border-white/10" testid="trainees-learn">
        <SectionTitle eyebrow="What You Can Learn" title="Skills and habits you will build." />
        <BulletGrid items={LEARN} testid="trainees-learn-grid" />
      </Section>

      <Section testid="trainees-good">
        <SectionTitle eyebrow="What Makes a Good School Bus Driver" title="More than a job description." />
        <BulletGrid items={GOOD} testid="trainees-good-grid" />
      </Section>

      <CTABand title="Ready to begin?" description="Reach out to learn how CLB Solution can support your training journey." />
    </>
  );
}
